const AUTHENTICATION_FAILED = 'authentication_failed';
const CART_NOT_ACTIVE = 'cart_not_active';
const CART_NOT_FOUND = 'cart_not_found';
const DOWNLOAD_CART_NO_SHIPPING = 'download_cart_no_shipping';
const NOT_AUTHORIZED = 'base_unauthorized';
const PLACE_ORDER_FAILED = 'place_order_failed';

export {
  AUTHENTICATION_FAILED,
  CART_NOT_ACTIVE,
  CART_NOT_FOUND,
  DOWNLOAD_CART_NO_SHIPPING,
  NOT_AUTHORIZED,
  PLACE_ORDER_FAILED,
};
